import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import useInventory, { ContentInventory, InventoryVersion } from '../../hooks/useInventory';
import InventoryTemplateAutocomplete, { InventoryTemplateValue } from '../common/InventoryTemplateAutocomplete';

interface QuickSelectInventoryProps {
    setSelectedInventoryVersion: React.Dispatch<React.SetStateAction<InventoryVersion | undefined>>;
    setSelectedInventory?: React.Dispatch<React.SetStateAction<ContentInventory | undefined>>;
    value?: InventoryTemplateValue | null;
    onClear?: () => void;
}

const QuickSelectInventory = ({ setSelectedInventoryVersion, setSelectedInventory, value, onClear }: QuickSelectInventoryProps) => {
    const { isLoading: isInventoryLoading } = useInventory();

    return (
        <Box sx={{ p: 0, width: '100%', pb: 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="subtitle1" fontWeight={700}>
                    Autofill from Templates
                </Typography>
                {isInventoryLoading && <CircularProgress size={16} sx={{ ml: 1 }} />}
            </Box>
            <InventoryTemplateAutocomplete
                setSelectedInventoryVersion={setSelectedInventoryVersion}
                setSelectedInventory={setSelectedInventory}
                value={value}
                onClear={onClear}
            />
        </Box>
    );
};

export default QuickSelectInventory;
